import React, { useContext } from 'react';
import { AuthContext, useNavigate } from 'components/lib';
import { GeodataContext } from 'contexts/GeodataContext';
import { GridContext } from 'contexts/GridContext';
import { SimulationContext } from 'contexts/SimulationContext';
import { ValidationContext } from 'contexts/ValidationContext';
import { UMButton } from '@urbanmetrix/um-kit';

type AddGridButtonProps = {
  projectId?: string | number | null;
  supportFlagged?: boolean;
  style?: React.CSSProperties;
};

const AddGridButton: React.FC<AddGridButtonProps> = ({ projectId, supportFlagged, style }) => {
  const { clearValidationForGridName, clearValidationForGridAnalysisArea, clearValidationForGridCoordinateSystem } =
    useContext(ValidationContext);
  const { clearGridFormData, setIsCloningGrid } = useContext(GridContext);
  const { clearGeodataFormData } = useContext(GeodataContext);
  const { clearSimulationFormData, setIsCloningSimulation } = useContext(SimulationContext);
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const canCreateInProject =
    Boolean(authContext.permission?.editor) || (Boolean(authContext.permission?.support) && Boolean(supportFlagged));

  const handleAddGrid = () => {
    clearGridFormData();
    clearGeodataFormData();
    clearSimulationFormData();
    clearValidationForGridName();
    clearValidationForGridAnalysisArea();
    clearValidationForGridCoordinateSystem();
    setIsCloningGrid(false);
    setIsCloningSimulation(false);
  };

  return (
    <>
      {projectId && (
        <UMButton
          text="Add Grid"
          disabled={!canCreateInProject}
          onClick={() => {
            handleAddGrid();
            navigate(`/projects/add?step=grid&projectId=${projectId}`);
          }}
          style={style}
        />
      )}

      <br />
    </>
  );
};

export default AddGridButton;
